module.exports = __webpack_public_path__ + "static/media/terms004.ac47852e.png";